import React, { Component, useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
import { getDatabase, ref, set, onValue } from "firebase/database";
import firebase from '../../utils/firebase';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Upload } from "./../addProduct/upload/Upload";

import styles from './AddProduct.module.css';

export const AddProduct = ({ showModalAddProduct, hideAddProduct, address }) => {

    const [sushi, setSushi] = useState([]);
    const [name, setName] = useState('');
    const [weight, setWeight] = useState('');
    const [description, setDescription] = useState('');
    const [price, setPrice] = useState('');
    const [url, setUrl] = useState('');

    useEffect(() => {
        const db = getDatabase(firebase);
        const name = ref(db, `/${address}`);
        onValue(name, (snapshot) => {
            const sushi = snapshot.val();
            setSushi({ sushi });
        });
    }, [])

    const handleNameChange = (event) => {
        setName(event.target.value)
    }

    const handleWeightChange = (event) => {
        setWeight(event.target.value)
    }

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value)
    }

    const handlePriceChange = (event) => {
        setPrice(event.target.value)
    }

    const clearForm = () => {
        setUrl('')
        setName('')
        setWeight('')
        setDescription('')
        setPrice('')
    }

    const sendData = () => {
        const database = getDatabase(firebase);
        set(ref(database, `/${address}/${name}`), {
            name,
            description,
            weight,
            price,
            url
        })
        hideAddProduct()
        clearForm()
    }

    // callback that reseive image url
    let takeImageUrl = (value) => {
        setUrl(value)
    }



    // const storageRef = ref(storage, 'images/' + file.name);
    // const uploadTask = uploadBytesResumable(storageRef, file, metadata);

    // const storage = getStorage();
    // const storageRef = ref(storage, 'img/logo.jpg');
    // uploadBytes(storageRef, file).then((snapshot) => {
    //     console.log('Uploaded a blob or file!');
    //   });


    return (
        <div className={showModalAddProduct ? styles.modal + ' ' + styles.displayBlock : styles.modal + ' ' + styles.displayNone} 
            onClick={hideAddProduct}
        >
            <div className={styles.modalContent} onClick={event => event.stopPropagation()}>

                <div className={styles.inputContainer}>
                    <div>
                        <Upload takeImageUrl={takeImageUrl} />
                    </div>
                    <div>
                        <TextField
                            type="text"
                            id="name"
                            name='name'
                            value={name}
                            placeholder="назва"
                            onChange={handleNameChange}
                            variant="standard"
                        />
                    </div>
                    <div>
                        <TextField
                            type="text"
                            id="weight"
                            name='weight'
                            value={weight}
                            placeholder="вага"
                            onChange={handleWeightChange}
                            variant="standard"
                        />
                    </div>
                    <div>
                        <TextField
                            type="text"
                            id="description"
                            name='description'
                            value={description}
                            placeholder="опис"
                            onChange={handleDescriptionChange}
                            variant="standard"
                        />
                    </div>
                    <div>
                        <TextField
                            type="text"
                            id="price"
                            name='price'
                            value={price}
                            placeholder="ціна"
                            onChange={handlePriceChange}
                            variant="standard"
                        />
                    </div>

                {/* {(address == 'rolls') && (<div>'yo'</div>)} */}

                </div>

                <button type="submit"
                    className={styles.button}
                    onClick={sendData}
                >Додати</button>
            </div>
        </div>
    );
};